export default __webpack_public_path__ + "1b892d934bd269758985ba832abf808a.jpg";